import type { ReactNode } from 'react';
import { PanelRightClose } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * The header of the docked compile and history panels. Same height as the protocol top bar,
 * so the two bottom borders run as one line across the page.
 */
export function PanelHeader({
	title,
	status,
	actions,
	onClose
}: {
	title: string;
	status: ReactNode;
	/** Buttons shown before Close. */
	actions?: ReactNode;
	onClose: () => void;
}) {
	return (
		<div className='flex h-15 shrink-0 items-center gap-2 border-b border-gray-500 px-4'>
			<div className='flex min-w-0 flex-1 flex-col'>
				<p className='text-sm leading-5 font-medium text-text-heading'>{title}</p>
				<div className='truncate text-xs leading-4 text-gray-800'>{status}</div>
			</div>
			{actions}
			<Button variant='ghost' size='icon-sm' className='shrink-0 text-gray-900' onClick={onClose} aria-label='Close panel'>
				<PanelRightClose className='size-4' />
			</Button>
		</div>
	);
}
